import React, { useCallback } from "react";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import Modal from "modules/Modal/Modal";
import DailyInspectionForm from "./DailyInspectionForm";
import useModalState from "hooks/useModalState";
import useCreateDailyFormInspection from "hooks/fleet/useCreateDailyFormInspection";
import { CreateDailyFormInspectionInput } from "generated/graphql";

export default function CreateDailyInspectionModal() {
  const { open, onClose, onOpen } = useModalState();
  const [createInspection, { loading: creating }] = useCreateDailyFormInspection();

  const handleFormSubmit = useCallback(
    async (data: CreateDailyFormInspectionInput) => {
      const result = await createInspection({
        variables: {
          input: data,
        },
      });

      if (result.data?.createDailyFormInspection) {
        onClose();
      }
    },
    [createInspection, onClose]
  );

  const handleCancel = useCallback(() => {
    onClose();
  }, [onClose]);

  const modalStyles = {
    height: "auto",
    maxHeight: "90vh",
    width: "90vw",
    maxWidth: "800px",
    overflow: "auto",
  };

  return (
    <>
      <MDButton variant="gradient" color="success" onClick={onOpen}>
        Create Daily Inspection
      </MDButton>

      <Modal open={open} onClose={onClose} styles={modalStyles}>
        <MDBox p={3}>
          <MDTypography variant="h5" fontWeight="medium" mb={3}>
            Create Daily Inspection
          </MDTypography>

          <DailyInspectionForm
            type="create"
            onSubmit={handleFormSubmit}
            onCancel={handleCancel}
            loading={creating}
          />
        </MDBox>
      </Modal>
    </>
  );
}
